import { formatInputNumber, roundNumber } from '@pretto/bricks/core/utility/formatters'

export const renderValue = (value, roundTo = 1) => formatInputNumber(roundNumber(value, roundTo))
